export default __webpack_public_path__ + "static/media/aw.aa60540f.svg";